import { defineComponent, h } from "vue";
import { td, th, tr, tbody, thead, table } from "./getTableComponentProps.js";
const defaultTableComponents = {
  table: defineComponent({
    props: table(),
    setup(props, { slots }) {
      return () => h("table", slots.default ? slots.default() : []);
    }
  }),
  thead: defineComponent({
    props: thead(),
    setup(props, { slots }) {
      return () => h("thead", slots.default ? slots.default() : []);
    }
  }),
  tbody: defineComponent({
    props: tbody(),
    setup(props, { slots }) {
      return () => h("tbody", slots.default ? slots.default() : []);
    }
  }),
  tr: defineComponent({
    props: tr(),
    setup(props, { slots }) {
      return () => h("tr", slots.default ? slots.default() : []);
    }
  }),
  th: defineComponent({
    props: th(),
    setup(props, { slots }) {
      return () => h("th", slots.default ? slots.default() : []);
    }
  }),
  td: defineComponent({
    props: td(),
    setup(props, { slots }) {
      return () => h("td", slots.default ? slots.default() : []);
    }
  })
};
export {
  defaultTableComponents
};
//# sourceMappingURL=PrismicTableDefaultComponents.js.map
